 export {LibComponent,LibService,PdfViewerModule} from './module/lib.module';
//export * from './module/pdf-viewer/pdf-viewer.module';
